var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownIconNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99177 8.24947C5.81689 8.24982 5.6474 8.18879 5.51275 8.07697L1.77039 5.07697C1.61754 4.94967 1.52141 4.76674 1.50317 4.56842C1.48492 4.3701 1.54604 4.17264 1.67309 4.01947C1.80013 3.86631 1.98269 3.76999 2.18061 3.75171C2.37852 3.73342 2.57558 3.79467 2.72843 3.92197L5.99177 6.53197L9.2551 4.04197C9.33166 3.97968 9.41976 3.93315 9.51432 3.90508C9.60888 3.877 9.70804 3.86793 9.80612 3.87839C9.90419 3.88884 9.99923 3.91861 10.0858 3.966C10.1723 4.01338 10.2487 4.07743 10.3104 4.15447C10.379 4.23159 10.4309 4.32206 10.4629 4.42022C10.495 4.51837 10.5064 4.6221 10.4966 4.72489C10.4867 4.82769 10.4558 4.92735 10.4058 5.01761C10.3557 5.10788 10.2876 5.18682 10.2057 5.24947L6.4633 8.12197C6.32477 8.21611 6.15875 8.261 5.99177 8.24947Z",
    fill: "#0F172A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownIconNew);
export default __webpack_public_path__ + "static/media/downIconNew.38aeb92252c160ec838b93c57c671c26.svg";
export { ForwardRef as ReactComponent };